"use strict";
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
const StarFilled = (props) => {
  const { className, size = IconSize.Medium, color = "inherit", ...rest } = props;
  const iconClass = classNames(
    styles.icon({
      size,
      color
    }),
    "kl-icon",
    `kl-icon--${size}`,
    className
  );
  return React.createElement(
    "svg",
    { width: "24", height: "24", viewBox: "0 0 24 24", className: iconClass, ...rest },
    /* @__PURE__ */ React.createElement("path", { d: "M16.67 20.67a1.83 1.83 0 01-.91-.25L12 18.15l-3.76 2.27a1.72 1.72 0 01-1.31.2 1.76 1.76 0 01-1.3-2.1l1-4.28-3.33-2.88a1.75 1.75 0 011-3.07l4.38-.37 1.71-4a1.76 1.76 0 012.269-.932 1.741 1.741 0 01.951.942l1.71 4 4.38.37a1.75 1.75 0 011 3.07l-3.33 2.88 1 4.28c.106.443.034.91-.2 1.3a1.78 1.78 0 01-1.08.8 2.001 2.001 0 01-.42.04z" })
  );
};
export default StarFilled;
